export var StorageKey;
(function (StorageKey) {
    StorageKey["AnonymousUserId"] = "AnonymousUserId";
    StorageKey["ShowBetaWarning"] = "ShowBetaWarning";
    StorageKey["ShowNoAccountWarning"] = "ShowNoAccountWarning";
    StorageKey["FilesNavigationEnabled"] = "FilesNavigationEnabled";
    StorageKey["MasterStatePersistenceKey"] = "master-persistence-key";
})(StorageKey || (StorageKey = {}));
export const storage = {
    get(key) {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    },
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    remove(key) {
        localStorage.removeItem(key);
    },
};
